// 静态页面模拟图2
import * as React from 'react';

export default () => (
  <div>
    <h1>Home Page</h1>
  </div>
);
